import React from 'react';
import { partial } from 'lodash';

const defaultMergeProps = (partialProps: any, props: any) => ({
  ...partialProps,
  ...props,
});

const createRenderCallbackWith = (
  mergeProps: any,
  Component: React.ComponentType,
  partialProps: any
) => (props: any) => <Component {...mergeProps(partialProps, props)} />;

const createRenderCallback = partial(
  createRenderCallbackWith,
  defaultMergeProps
);
export default createRenderCallback;
